export default "__VITE_ASSET__D83KJ9uh__"